import CallServiceTable from "../../components/Tables/CallServiceTable";
import { H3, Anchor } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import TableComplete from "../../components/Tables/TableComplete";
import { Circle } from "../../components/Animation";
import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import { useAuth } from "../../contexts/AuthContext";
import { Request } from "../../hooks/Request";
import ListDocument from "../../components/common/ListDocument";
import ServiceOrderPDF from "../../containers/ManegeProcedure/ServiceOrderPDF";
import dayjs from "dayjs";
import CustomsClearancePdf from "../../containers/ManegeProcedure/CustomsClearancePdf";
import config from "../../config.json";
import { validateArray } from "../../utils/validate";
import { RenderGenerateSpreadsheet } from "../../containers/GenerateExcel/CloneItems";

const ClientList = () => {
  const { user } = useAuth();
  const { openDialog } = useDialog();
  const { openModal, onClose } = useModal();

  function listDocumentPdf(procedure) {
    openDialog(<RenderPdf procedure={procedure} />);
  }
  function generateSettlementProforma(procedure) {
    openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  }
  function viewProcedure(procedure) {
    openModal(
      <ProcedureData
        procedure={procedure}
        onClose={onClose}
        user={user}
        openDialog={openDialog}
      />,
    );
  }

  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} deleteDocument={false} />);
  }

  // async function handleFormQuotes(procedure) {
  //   const notesValueData = await getNotesValueData();
  //   openDialog(
  //     <CustomsClearanceQuote
  //       procedure={procedure}
  //       notesValueData={notesValueData}
  //     />
  //   );
  // }

  function generateServiceOrder(procedure) {
    openDialog(
      <ServiceOrderPDF procedure={{ ...procedure, id: procedure.id }} />,
    );
  }

  return (
    <div>
      <CallServiceTable
        onClick={viewProcedure}
        urlApi={`Procedure/custom-report/companyId/${user?.company[0]?.id}/pag`}
        addFilters={[
          {
            name: "internCode",
            label: "Interno",
            filter: true,
          },
          {
            name: "dimNumber",
            label: "Número de DIM",
            filter: true,
          },
          // {
          //   name: 'clientCode',
          //   label: 'Código de Cliente',
          //   filter: true,
          // },
          // {
          //   name: 'billNumber',
          //   label: 'Número de factura',
          //   filter: true,
          // },
          // {
          //   name: 'docEmbarque',
          //   label: 'Nro de embarque',
          //   filter: true,
          // },
        ]}
        filters={[
          {
            name: "ForQueryDate",
            label: "Validar fecha por ...",
            options: [
              {
                label: "Fecha de validación",
                name: "validationDate",
              },
              {
                label: "Fecha de inicio",
                name: "procedureStartDate",
              },
            ],
          },
          {
            // url: '/company/getallcompanies',
            // name: 'companyId',
            // valueOption: 'id',
            // labelOption: 'razonSocial',
            type: "rangeDate",
          },
        ]}
        header={[
          // {
          //   name: "companyName",
          //   label: "Compañía",
          //   filter: false,
          // },
          {
            name: "reference",
            label: "Interno",
          },
          {
            name: "dimNumber",
            label: "Número de DIM",
          },
          {
            name: "nroFactura",
            label: "Nro. Factura",
          },
          {
            name: "chasisNumber",
            label: "Nro. Chasis",
          },
          {
            name: "docEmbarque",
            label: "Doc. Embarque",
          },
          // {
          //   name: "Reports",
          //   type: "action",
          //   label: "Reportes",
          //   actions: [
          //     {
          //       label: "Reporte de liquidación",
          //       icon: "fas fa-print",
          //       action: generateServiceOrder,
          //       color: "text-[#1d4ed8]",
          //     },
          //     {
          //       label: "Ver documentos",
          //       icon: "fa-solid fa-folder",
          //       action: handleDocument,
          //       color: "text-[#1d4ed8]",
          //     },
          //     // {
          //     //   label: "Cotización",
          //     //   icon: "fas fa-hand-holding-usd",
          //     //   action: handleFormQuotes,
          //     //   color: "text-[#1d4ed8]",
          //     // },
          //     // {
          //     //   label: "Generar informe de la recepción de documentos",
          //     //   icon: "fas fa-tasks",
          //     //   action: listDocumentPdf,
          //     //   color: "text-[#1d4ed8]",
          //     // },
          //     // {
          //     //   label: "Generar liquidación - proforma",
          //     //   icon: "fas fa-coins",
          //     //   action: generateSettlementProforma,
          //     //   color: "text-[#1d4ed8]",
          //     // },
          //   ],
          // },
        ]}
        addUrl={`userId=${localStorage.getItem("id")}`}
        statusPaination={false}
        showTable={true}
      />
    </div>
  );
};

const listData = [
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "asignarRégimenDeImportación",
  "a2FechaDeAceptación",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "proveedor",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",

  "fechaPagoDeLaDim",
  "fechaDePlanilla",
  "canal(Rojo,AmarilloOVerde)",
  "a4AduanaDeDespacho",
  "nroFacturaComercial",
  "erogaciones",
  "honorariosProfesionales",

  "a-TributosYOtrosConceptosAduaneros",
  "b-OtrosGastosDeImportacion/Exportacion",
  "c-GastosDeOperaciones",
];

const ProcedureData = ({ procedure, openDialog }) => {
  console.log("🚀 ~ ProcedureData ~ procedure:", procedure);
  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.procedureId}/dataValues?${listData
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const { data: dataStateAccount, isLoading: isLoadingStateAccount } = Request({
    urlApi: `${config.requestURLConta}/api/StateAccount/${procedure.procedureId}`,
  });

  if (!loading && !isLoadingStateAccount) {
    return <Circle />;
  }

  function handlePlanilla() {
    if (data.category) {
      if (data.category === "multiple") {
        openDialog(
          <RenderGenerateSpreadsheet
            limit={{
              From: "1",
              To: "1",
            }}
            items={[{ ...procedure }]}
            dataProcedure={data}
            dataStateAccount={dataStateAccount}
          />,
        );
      } else {
        openDialog(
          <CustomsClearancePdf
            procedure={{ ...procedure, procedureId: procedure.procedureId }}
          />,
        );
      }
    }
  }

  const TextData = ({ title, children }) => {
    if (children) {
      return (
        <div className="flex gap-4 p-2 bg-white mb-2 rounded-md">
          <h3 className="font-semibold">{title}:</h3>
          <h4>{children}</h4>
        </div>
      );
    }
    return null;
  };
  return (
    <div>
      <div className="mb-2 rounded-md p-2">
        <h3 className="text-xl font-semibold text-center mb-3">Datos</h3>
        <TextData title="DIM adjuntada">
          {procedure?.dimUrl && procedure.dimUrl !== "-" ? (
            <a
              className="text-blue-600 underline"
              href={procedure.dimUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Enlace del documento
            </a>
          ) : (
            "-"
          )}
        </TextData>
        <TextData title="Planilla">
          <h3 className="text-blue-600 underline" onClick={handlePlanilla}>
            Enlace de la Planilla
          </h3>
        </TextData>
        {dataStateAccount?.items && validateArray(dataStateAccount?.items)
          ? dataStateAccount?.items
              .filter((item) => item.type === 8)
              .map((item) => (
                <TextData title="Factura">
                  {item?.refSiatUrl && item?.refSiatUrl !== "-" ? (
                    <a
                      className="text-blue-600 underline"
                      href={item?.refSiatUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Enlace de la Factura
                    </a>
                  ) : (
                    "-"
                  )}
                </TextData>
              ))
          : null}
      </div>
    </div>
  );
};

export default ClientList;
